import React from 'react';
import { useLocation } from 'react-router-dom';
import Icon from '../Icon';
import usePageMeta from '../usePageMeta';
import { ContactDetails } from '../components/ContactSection';
import ContactForm from '../components/ContactForm';
import OfficeMap from '../components/OfficeMap';
import { topicFromSearch } from '../topics';
import { useContact } from '../SiteContent';
import T from '../components/EditableText';

const Kontakt: React.FC = () => {
  // Über die Schaltflächen der Unterseiten kommt das Anliegen als ?thema= mit.
  const topic = topicFromSearch(useLocation().search);
  const contact = useContact();

  usePageMeta(
    'Kontakt & kostenlose Beratung in Gifhorn',
    `Seniorenbetreuung Antczak, ${contact.address}. Anruf unter ${contact.phoneLabel} oder Nachricht über das Formular — das Erstgespräch ist kostenlos.`,
    { standaloneTitle: true },
  );

  return (
    <>
      {/* Eine dunkle Fläche: links Ansprache und Kontaktwege, rechts das Formular */}
      <section className="shell hx-hero-wrap">
        <div className="hx-contact-hero">
          <div className="hx-contact-hero__info">
            <span className="eyebrow eyebrow--on-image">
              <T k="kontakt.hero.eyebrow" />
            </span>
            <h1 className="h-page hx-hero__title">
              <T k="kontakt.hero.titel" />{' '}
              <span className="accent">
                <T k="kontakt.hero.titel-akzent" />
              </span>
            </h1>
            <p className="hx-hero__lead">
              <T k="kontakt.hero.lead" />
            </p>
            <h2 className="hx-contact-hero__label">
              <T k="kontakt.daten.titel" />
            </h2>
            <ContactDetails />
          </div>

          <div className="hx-contact-hero__form form-first">
            <h2 className="h-card">
              <T k="kontakt.formular.titel" />
            </h2>
            <p>
              <T k="kontakt.formular.text" />
            </p>
            <ContactForm topic={topic} messagePlaceholder="Wie können wir helfen?" />
          </div>
        </div>
      </section>

      {/* Erreichbarkeit und Anfahrt */}
      <section className="shell section hx-twocol hx-visit">
        <div>
          <h2 className="h-block">
            <T k="kontakt.erreichbarkeit.titel" />
          </h2>
          <p className="hx-muted-lead">
            <T k="kontakt.erreichbarkeit.text" />
          </p>
          <a href={contact.directionsHref} className="textlink" target="_blank" rel="noopener noreferrer">
            <T k="kontakt.karte.link" /> <Icon name="arrow-right" size={16} />
          </a>
        </div>
        <OfficeMap />
      </section>
    </>
  );
};

export default Kontakt;
